import React from 'react';
import { connect } from 'react-redux';
import { LabelsSidebar } from '../labels_sidebar/LabelsSidebar';
import { Label, LabelEntityType } from '../../types/labels';
import {
	labelsOnPartsRestCrudThunksForSupplier,
	syncPartLabelsForSupplier,
} from '../../thunks/labels_thunks';
import { getRecordsForTargetCollection } from '../../reducers/standard_reducer_utils';
import { RootState } from '../../reducers/root_reducer';
import { pickRandomLabelColor } from '../../constants/labelConstants';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';

interface OwnProps {
	onClose?: () => void;
	targetCollectionName: LabelEntityType;
	// Called after the label catalogue is successfully created/updated/deleted — lets
	// callers refetch dependents (part rows, the dropdown catalogue).
	onLabelsCatalogueSaved?: () => void | Promise<void>;
	// When provided, the per-label count becomes clickable — the parent closes the
	// sidebar and applies that label as the Parts index filter.
	onLabelCountClick?: (label: Label) => void;
	// Parts table collection whose filters may reference a label being deleted.
	listTargetCollectionName?: string;
}

// Parts flavor of the shared LabelsSidebar: part-count accessor and the parts labels
// slice/thunks. Reused by both the Parts index "Labels" button and the Add Label
// modal's EDIT button.
const PartsLabelsManagementPage: React.FC<any> = (props) => (
	<LabelsSidebar
		{...props}
		// Parts labels have no access-permission gating — anyone can manage them.
		canModifyLabels
		getCount={(label) => nullSafeGetOrElse('associatedPartsCount', label, 0)}
		pickNewLabelColor={pickRandomLabelColor}
		deleteWarningEntityNoun="parts"
	/>
);

const mapStateToProps = (state: RootState, ownProps: OwnProps) => ({
	labels: getRecordsForTargetCollection(state.labels, ownProps.targetCollectionName) || [],
	fetching: nullSafeGetOrElse(`${ownProps.targetCollectionName}.fetching`, state.labels, false),
});
const mapDispatchToProps = (dispatch: any, ownProps: OwnProps) => ({
	fetchAllLabels: () =>
		dispatch(
			labelsOnPartsRestCrudThunksForSupplier.read(
				{ no_pagination: true },
				ownProps.targetCollectionName,
				null,
				{
					sort_by: 'associatedPartsCount',
					order: 'desc',
				}
			)
		),
	syncLabels: (entries) =>
		dispatch(
			syncPartLabelsForSupplier(entries, {
				targetCollectionName: ownProps.listTargetCollectionName,
			})
		),
});

// @ts-ignore - Type inference issue with HOC composition, same pattern as PartsLabelCreationButton
export default connect(mapStateToProps, mapDispatchToProps)(PartsLabelsManagementPage);
